export default {
  chatTab_tooltip_groupConversation_all_messages:
    'All new messages will notify you',
  chatTab_tooltip_groupConversation_mentions:
    'Channel is muted. Only mentions will notify you',
  chatTab_tooltip_groupConversation_direct_mention:
    'Channel is muted. Only direct mentions will notify you',
};
